import { createApiCallActions } from '../../../common/store/generic.actions';
import { ChequeRemittanceModel } from './types';

export const chequeRemittanceActions = {
  getById: createApiCallActions<ChequeRemittanceModel>(
    'chequeRemittance',
    'getById',
  ),
  createInstance: createApiCallActions<ChequeRemittanceModel>(
    'chequeRemittance',
    'createInstance',
  ),
  add: createApiCallActions<ChequeRemittanceModel>('chequeRemittance', 'add'),
  delete: createApiCallActions<boolean>('chequeRemittance', 'delete'),
  deleteFromList: createApiCallActions<boolean>(
    'chequeRemittance',
    'deleteFromList',
  ),
  getChequeRemittancePdf: createApiCallActions<any>(
    'chequeRemittance',
    'getChequeRemittancePdf',
  ),
};

export type ChequeRemittanceAction = typeof chequeRemittanceActions;
